var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movie-options"},[(_vm.playlistEnabled)?_c('playlist-menu'):_vm._e(),(_vm.isLoggedIn && _vm.vrackEnabled)?_c('vrack-download-button'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }